'use strict';

import angular from 'angular';

/**
 * @ngdoc service
 * @name observatoireApp.service:ConventionsMiniereService
 * @description
 * # ConventionsMiniereService
 * Service pour la gestion des conventions minières
 */
angular.module('observatoireApp')
  .service('ConventionsMiniereService', ['$http', '$q', function($http, $q) {
    
    // Données mockées pour les conventions minières
    const conventionsMinieresMock = [
      {
        id: 1,
        societe: "TCHAD MINING AND EXPLORATION",
        projet: "Exploration et exploitation du minerai d'or",
        substance: "Or",
        region: "Mayo-Kebbi Ouest",
        dateSignature: "2007-05-21",
        duree: 25,
        statut: "En vigueur",
        superficie: 35000,
        investissement: 1500000,
        emploisDirects: 200,
        emploisIndirects: 500,
        detailsProduction: "Plus de 500 kg d'or par an",
        dateDerniereModification: "2023-03-15"
      },
      {
        id: 2,
        societe: "SOCIETE MINIÈRE DE PALA",
        projet: "Exploitation de mines d'or et de diamants",
        substance: "Or, Diamant",
        region: "Mayo-Kebbi Est",
        dateSignature: "2011-07-18",
        duree: 20,
        statut: "En vigueur",
        superficie: 28500,
        investissement: 2300000,
        emploisDirects: 180,
        emploisIndirects: 450,
        detailsProduction: "300 kg d'or et 5000 carats de diamants par an",
        dateDerniereModification: "2024-01-10"
      },
      {
        id: 3,
        societe: "COMPAGNIE TCHADIENNE D'EXPLOITATION MINIÈRE",
        projet: "Exploitation de gisements de natron",
        substance: "Natron",
        region: "Kanem",
        dateSignature: "2015-09-05",
        duree: 15,
        statut: "En vigueur",
        superficie: 42000,
        investissement: 800000,
        emploisDirects: 120,
        emploisIndirects: 300,
        detailsProduction: "20000 tonnes de natron par an",
        dateDerniereModification: "2023-11-28"
      },
      {
        id: 4,
        societe: "TCHAD URANIUM CORPORATION",
        projet: "Exploration et exploitation d'uranium",
        substance: "Uranium",
        region: "Tibesti",
        dateSignature: "2013-03-30",
        duree: 30,
        statut: "Suspendu",
        superficie: 65000,
        investissement: 5000000,
        emploisDirects: 350,
        emploisIndirects: 1200,
        detailsProduction: "Projet en phase d'exploration",
        dateDerniereModification: "2022-05-20"
      },
      {
        id: 5,
        societe: "SOCIETE D'EXPLOITATION DE CALCAIRE DU MAYO-KEBBI",
        projet: "Exploitation de calcaire pour cimenterie",
        substance: "Calcaire",
        region: "Mayo-Kebbi Ouest",
        dateSignature: "2018-11-12",
        duree: 25,
        statut: "En vigueur",
        superficie: 18000,
        investissement: 12000000,
        emploisDirects: 400,
        emploisIndirects: 1500,
        detailsProduction: "1.2 million de tonnes de calcaire par an",
        dateDerniereModification: "2024-02-18"
      },
      {
        id: 6,
        societe: "CONSORTIUM MINIER DU TCHAD ORIENTAL",
        projet: "Exploitation de gisements d'or et métaux associés",
        substance: "Or, Argent, Cuivre",
        region: "Ouaddaï",
        dateSignature: "2009-08-14",
        duree: 20,
        statut: "Expiré",
        superficie: 48000,
        investissement: 3200000,
        emploisDirects: 250,
        emploisIndirects: 750,
        detailsProduction: "Production arrêtée depuis 2019",
        dateDerniereModification: "2019-08-14"
      },
      {
        id: 7,
        societe: "TCHAD BAUXITE MINING",
        projet: "Exploration de bauxite",
        substance: "Bauxite",
        region: "Logone Oriental",
        dateSignature: "2020-02-25",
        duree: 15,
        statut: "En phase d'exploration",
        superficie: 25000,
        investissement: 4500000,
        emploisDirects: 85,
        emploisIndirects: 250,
        detailsProduction: "Phase d'exploration, aucune production",
        dateDerniereModification: "2024-03-01"
      },
      {
        id: 8,
        societe: "SOCIÉTÉ DE DÉVELOPPEMENT DES RESSOURCES MINÉRALES",
        projet: "Exploitation de sel gemme",
        substance: "Sel gemme",
        region: "Lac",
        dateSignature: "2016-06-10",
        duree: 18,
        statut: "En vigueur",
        superficie: 15000,
        investissement: 950000,
        emploisDirects: 110,
        emploisIndirects: 325,
        detailsProduction: "45000 tonnes de sel par an",
        dateDerniereModification: "2023-10-05"
      },
      {
        id: 9,
        societe: "CONSORTIUM DU GRANITE TCHADIEN",
        projet: "Exploitation de carrières de granite",
        substance: "Granite",
        region: "Guéra",
        dateSignature: "2019-04-18",
        duree: 20,
        statut: "En vigueur",
        superficie: 12000,
        investissement: 1800000,
        emploisDirects: 150,
        emploisIndirects: 420,
        detailsProduction: "80000 m³ de granite par an",
        dateDerniereModification: "2024-01-22"
      },
      {
        id: 10,
        societe: "SOCIÉTÉ DES MINÉRAUX RARES DU TCHAD",
        projet: "Exploration et exploitation de terres rares",
        substance: "Terres rares",
        region: "Borkou",
        dateSignature: "2021-09-30",
        duree: 35,
        statut: "En phase d'exploration",
        superficie: 75000,
        investissement: 8500000,
        emploisDirects: 65,
        emploisIndirects: 180,
        detailsProduction: "Études de faisabilité en cours",
        dateDerniereModification: "2023-12-15"
      }
    ];

    /**
     * Récupère toutes les conventions minières
     * @returns {Promise} Promesse contenant les conventions minières
     */
    this.getConventions = function() {
      // Dans un environnement réel, on ferait un appel à l'API
      // return $http.get('/api/conventions-minieres');
      
      // Pour le moment, on utilise des données mockées
      const deferred = $q.defer();
      
      // Simuler un délai réseau
      setTimeout(function() {
        deferred.resolve(conventionsMinieresMock);
      }, 500);
      
      return deferred.promise;
    };
    
    /**
     * Récupère une convention minière par son ID
     * @param {number} id Identifiant de la convention
     * @returns {Promise} Promesse contenant la convention
     */
    this.getConventionById = function(id) {
      const deferred = $q.defer();
      
      // Simuler un délai réseau
      setTimeout(function() {
        const convention = conventionsMinieresMock.find(c => c.id === parseInt(id));
        if (convention) {
          deferred.resolve(convention);
        } else {
          deferred.reject('Convention non trouvée avec ID: ' + id);
        }
      }, 300);
      
      return deferred.promise;
    };
    
    /**
     * Récupère les régions uniques des conventions minières
     * @returns {Array<string>} Liste des régions
     */
    this.getRegions = function() {
      return [...new Set(conventionsMinieresMock.map(c => c.region))].sort();
    };
    
    /**
     * Récupère les substances minières uniques
     * @returns {Array<string>} Liste des substances
     */
    this.getSubstances = function() {
      // Extraire toutes les substances, y compris celles séparées par des virgules
      const substances = conventionsMinieresMock
        .map(c => c.substance.split(',').map(s => s.trim()))
        .flat();
      
      // Retourner des valeurs uniques
      return [...new Set(substances)].sort();
    };
    
    /**
     * Récupère les statuts uniques
     * @returns {Array<string>} Liste des statuts
     */
    this.getStatuts = function() {
      return [...new Set(conventionsMinieresMock.map(c => c.statut))].sort();
    };
    
    /**
     * Recherche dans les conventions minières
     * @param {Object} criteres Critères de recherche
     * @returns {Promise} Promesse contenant les résultats filtrés
     */
    this.rechercher = function(criteres) {
      const deferred = $q.defer();
      
      setTimeout(function() {
        let resultats = conventionsMinieresMock;
        
        if (criteres) {
          if (criteres.texte) {
            const texte = criteres.texte.toLowerCase();
            resultats = resultats.filter(c => 
              c.societe.toLowerCase().includes(texte) ||
              c.projet.toLowerCase().includes(texte) ||
              c.substance.toLowerCase().includes(texte) ||
              c.region.toLowerCase().includes(texte)
            );
          }
          
          if (criteres.region) {
            resultats = resultats.filter(c => c.region === criteres.region);
          }
          
          if (criteres.substance) {
            resultats = resultats.filter(c => c.substance.includes(criteres.substance));
          }
          
          if (criteres.statut) {
            resultats = resultats.filter(c => c.statut === criteres.statut);
          }
          
          if (criteres.anneeMin) {
            const anneeMin = parseInt(criteres.anneeMin);
            resultats = resultats.filter(c => {
              const anneeSignature = new Date(c.dateSignature).getFullYear();
              return anneeSignature >= anneeMin;
            });
          }
          
          if (criteres.anneeMax) {
            const anneeMax = parseInt(criteres.anneeMax);
            resultats = resultats.filter(c => {
              const anneeSignature = new Date(c.dateSignature).getFullYear();
              return anneeSignature <= anneeMax;
            });
          }
        }
        
        deferred.resolve(resultats);
      }, 300);
      
      return deferred.promise;
    };
    
    /**
     * Exportation des données au format Excel
     * @param {Array} donnees Données à exporter
     * @returns {Promise} Promesse contenant les données au format blob
     */
    this.exporterExcel = function(donnees) {
      // Dans une implémentation réelle, on appellerait un service backend pour générer l'Excel
      
      // Simuler une réponse
      const deferred = $q.defer();
      
      setTimeout(function() {
        deferred.resolve({
          data: new Blob(['Données des conventions minières'], {type: 'application/vnd.ms-excel'}),
          headers: function() { return 'application/vnd.ms-excel'; }
        });
      }, 500);
      
      return deferred.promise;
    };
  }]);
